import { create } from "zustand";

export type ToastKind = "success" | "error" | "info";

export type ToastItem = {
  id: string;
  kind: ToastKind;
  message: string;
};

type ToastState = {
  items: ToastItem[];
  push: (kind: ToastKind, message: string) => string;
  dismiss: (id: string) => void;
};

const newId = () => Math.random().toString(36).slice(2);

export const useToastStore = create<ToastState>((set) => ({
  items: [],
  push: (kind, message) => {
    const id = newId();
    set((s) => ({ items: [...s.items, { id, kind, message }].slice(-3) }));
    if (kind !== "error") {
      setTimeout(() => {
        set((s) => ({ items: s.items.filter((i) => i.id !== id) }));
      }, 4000);
    }
    return id;
  },
  dismiss: (id) =>
    set((s) => ({ items: s.items.filter((i) => i.id !== id) })),
}));

export const toast = {
  success: (m: string) => useToastStore.getState().push("success", m),
  error: (m: string) => useToastStore.getState().push("error", m),
  info: (m: string) => useToastStore.getState().push("info", m),
};
